import { Component, OnInit, Inject } from '@angular/core';
import { EmbedVideoService } from 'ngx-embed-video';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-youtube-lightbox',
  templateUrl: './dialog-youtube-lightbox.component.html',
  styleUrls: ['./dialog-youtube-lightbox.component.scss']
})
export class DialogYoutubeLightboxComponent implements OnInit {
  ytIframeHtml: any;
  youtubeUrl = 'https://www.youtube.com/watch?v=';

  constructor(
    private embedService: EmbedVideoService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.ytIframeHtml = this.embedService.embed(this.youtubeUrl + this.data.id, {
      query: { portrait: 0, color: '333' },
      attr: {
        width: window.innerWidth < 800 ? window.innerWidth / 3 * 2 : 800,
        height: window.innerHeight < 600 ? window.innerWidth / 3 * 2 : 500
        }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
